import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { useTranslation } from '@stepstone-platform/i18n';
import { Flex, Paragraph } from '@stepstone-genesis/components';
import { ContentHeading } from '../../../../../components/common/ContentHeading/index.js';
export const HeadingWithText = () => {
    const { t } = useTranslation();
    const headerLabel = t('loginregistration.twoStepLoginRegistration.appleUpdateEmail.header');
    const headerDescriptionLabel = t('loginregistration.twoStepLoginRegistration.appleUpdateEmail.headerDescription');
    return (_jsxs(Flex, { flxDirection: 'column', gap: ['spaceS', 'spaceS2', 'spaceM'], children: [_jsx(ContentHeading, { label: headerLabel }), _jsx(Paragraph, { children: headerDescriptionLabel })] }));
};
//# sourceMappingURL=HeadingWithText.js.map